<template>
  <v-app>
    <global-header v-if="userLoggedIn" />

    <v-main>
      <router-view></router-view>
      <global-eventSelectorMobile />
    </v-main>

    <global-footer v-if="userLoggedIn" />
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";

/* eslint-disable no-unused-vars */
export default {
  data: () => ({
    polling: null,
  }),
  computed: {
    ...mapState("app", ["userLoggedIn"]),
    ...mapState("filter", ["globalEventFilter"]),
  },
  created() {
    // Clear sensitive data when browser is closed or refreshed
    window.addEventListener("beforeunload", () => {
      // Clear localStorage items that could contain sensitive data
      localStorage.removeItem("accessToken");
      localStorage.removeItem("accessUser");
      localStorage.removeItem("setSelectedEventId");
      localStorage.removeItem("setSelectedStallholderId");
    });
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "Dashboard";
    },
    "globalEventFilter.EventId"(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        console.log("EventId changed: ", newVal);
        // this.fetchStallHolders(newVal);
        if (this.userLoggedIn) {
          this.updateDashboard("Initial App.Vue Dashboard Update WITH EventId");
        }
      }
    },
    userLoggedIn(newValue, oldValue) {
      if (newValue === true) {
        this.initialLogin().then((response) => {
          console.log("Login Response", response);
          localStorage.setItem(
            "setSelectedEventId",
            response.RecentlyViewed.EventId
          );

          let selectedSid =
            response.fetchedRecentEvent.Stallholders[0].StallholderId;
          localStorage.setItem("setSelectedStallholderId", selectedSid);

          // this.updateDashboard("Initial App.Vue Dashboard Update");
        });
      } else {
        this.stopDashboardPolling();
        console.log("Stopped polling - user logged out");
      }
    },
  },
  methods: {
    ...mapActions("dashboard", [
      "updateDashboard",
      "startDashboardPolling",
      "stopDashboardPolling",
    ]),
    ...mapActions("filter", ["initialLogin"]),
  },
};
</script>

<style>
#app {
  /* color: blue; */
  background-color: #272b30;
}
</style>
